document.querySelectorAll('.ez-mods-btn').forEach(modsBtn => {
    modsBtn.addEventListener('click', (e) => {
        modRow = e.currentTarget.parentElement.nextElementSibling;
        console.log(modRow);
        if ( modRow instanceof HTMLElement && modRow.classList.contains('ez-item__row--mod') ) {
            modsBtn.classList.toggle('ez-mods-btn--active');
            modRow.classList.toggle('ez-item__row--hidden');
        }
        e.stopPropagation(); // Prevent other events on click this
    })
  });